import api from "src/apis/api"

// ── Invitations ──────────────────────────────────────────────────────────────
export async function fetchInvitations({ page = 1, per_page = 20 } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)

  const { data } = await api.get(`/api/v1/invitations?${params}`)
  return data
}

export async function createInvitation({ email, role_id }) {
  const { data } = await api.post("/api/v1/invitations", {
    invitation: { email, role_id }
  })
  return data
}

export async function deleteInvitation(id) {
  const { data } = await api.delete(`/api/v1/invitations/${id}`)
  return data
}

export async function resendInvitation(id) {
  const { data } = await api.post(`/api/v1/invitations/${id}/resend`)
  return data
}

// ── Invitation Acceptance (public endpoints) ────────────────────────────────
export async function fetchInvitationByUuid(uuid) {
  const { data } = await api.get(`/api/v1/invitation_acceptances/${uuid}`)
  return data
}

export async function acceptInvitation(uuid, userData) {
  const { data } = await api.post(`/api/v1/invitation_acceptances/${uuid}`, {
    user: userData
  })
  return data
}
